import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { StateService } from '../services/storage/state.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  private localStorageService = inject(LocalStorageService);
  private stateService = inject(StateService);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (isPlatformBrowser(this.platformId)) {
      if (this.stateService.isLoggedIn_()  || this.localStorageService.isLoggedIn || this.router.url === '/profile') {
        return true;
      }
      this.router.navigate(['/authenticate/login'], {
        queryParams: {
          checkout: state.url.includes('checkout') ? 'true' : 'false'
        }
      });
      return false;
    }

    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (isPlatformBrowser(this.platformId)) {
      if (this.stateService.isLoggedIn_()  || this.localStorageService.isLoggedIn || this.router.url.indexOf('/profile') !== -1) {
        return true;
      }
      this.router.navigate(['/authenticate/login'], {
        queryParams: {
          checkout: state.url.includes('checkout') ? 'true' : 'false'
        }
      });
      return false;
    }
    return true;
  }
}
